<template>
    <gcmcn-layout
        title="ALL FEEDS"
        custom-class="feed-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            :loading="!contentLoaded"
            @click="onCreateFeed"
        >
            Add feed
        </el-button>
        <ns-loader
            ref="nsLoader"
            :to-load="toLoad"
            :scoped="false"
            @dataFetched="onDataFetched"
        >
            <ns-loader-spinner slot="loader"></ns-loader-spinner>
            <template slot="content">
                <el-row :gutter="26" class="gcmcn-separator" :style="{height: `calc(100vh - ${this.$store.getters.pageHeight}px)`}">
                    <el-col :span="13" style="height: 100%;">
                        <feed-list
                            :selected-feed="selectedFeed"
                            :feeds="feeds"
                            :configurations="configurations"
                            :universes="universes"
                            :events="events"
                            :feed-resources="feedResources"
                            @select-feed="selectFeed"

                        ></feed-list>
                    </el-col>
                    <el-col :span="11" class="right-part">
                        <div>
                            <feed-form
                                v-if="displayFormView"
                                :events="events"
                                :universes="universes"
                                :feed-resources="feedResources"
                                :feed="selectedFeed"
                                :feeds="feeds"
                                @feed-created="feedCreated"
                                @leave-form-view="leaveFormView"
                            ></feed-form>
                            <feed-details
                                :key="selectedFeed.uid"
                                v-else-if="selectedFeed"
                                :feed="selectedFeed"
                                :events="events"
                                :feeds="feeds"
                                :feed-resources="feedResources"
                                :broadcast-right="broadcastRight"
                                @on-feed-stopped="onFeedStopped"
                                @on-update-broadcast-right="onUpdateRights"
                                @on-update-feed="onUpdateFeed"
                                @on-extend-feed="onExtendFeed"
                                @on-trigger-refresh="onTriggerRefresh"
                                @feed-created="feedCreated"
                                @unselectFeed="unselectFeed"
                                @getUpdatedFeed="getUpdatedFeed"
                            ></feed-details>
                        </div>
                    </el-col>
                </el-row>
            </template>
        </ns-loader>
    </gcmcn-layout>
</template>

<script>
import FeedList from './feed-list.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import FeedDetails from './feed-details.vue';
import FeedForm from './feed-form.vue';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
export default {

    components: {
        FeedList,
        FeedDetails,
        NsLoader,
        GcmcnLayout,
        FeedForm,
        NsLoaderSpinner,
    },

    props: {
    },

    data (){
        return {
            selectedFeed: null,
            broadcastRight: [],
            headerHeight: 233,
            contentLoaded: false,
            feeds: [],
            configurations: [],
            universes: [],
            events: [],
            feedResources: [],
            displayFormView: false,
        };
    },

    computed: {
        toLoad (){
            return [
                {
                    name: 'broadcastRight',
                    model: 'broadcastRight',
                    filters: {
                        feed__isnull: false,
                        archived: false,
                        revoked: false,
                    }
                },
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        cancelled: false,
                        archived: false,
                    }
                },
                {
                    name: 'universes',
                    model: 'universes',
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
                {
                    model: 'feedResources',
                    name: 'feedResources',
                    filters:{
                        archived: false,
                        is_manual: true,
                    }
                },
            ];
        },
    },

    methods: {
        unselectFeed() {
            this.$set(this, 'selectedFeed', null);
            this.$refs.nsLoader.triggerRefresh();
        },
        onCreateFeed (){
            this.$set(this, 'selectedFeed', null);
            this.displayFormView = true;
        },
        onUpdateFeed (){
            this.displayFormView = true;
        },
        onExtendFeed (){
            this.$refs.nsLoader.triggerRefresh();
        },
        onTriggerRefresh (){
            this.$refs.nsLoader.triggerRefresh();
        },
        feedCreated (){
            this.$refs.nsLoader.triggerRefresh();
            this.leaveFormView();
        },
        leaveFormView (){
            this.displayFormView = false;
        },
        selectFeed (feed){
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedFeed', feed);
        },
        getUpdatedFeed(feedUid){
            this.$store.dispatch('remoteGet', {url: `feed/?uid=${feedUid}`})
            .then(res =>{
                this.$set(this, 'selectedFeed', res.data.results[0]);
            })
        },
        onDataFetched (res){
            this.$set(this, 'broadcastRight', res.broadcastRight);
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'configurations', res.configurations);
            this.$set(this, 'universes', res.universes);
            this.$set(this, 'events', res.events);
            this.$set(this, 'feedResources', res.feedResources);
            if (this.selectedFeed && this.selectedFeed.uid) {
                this.$set(this, 'selectedFeed', res.feeds.find(feed => feed.uid === this.selectedFeed.uid));
            }
            this.contentLoaded = true;
            if(this.selectedFeed === null && this.$route.params.feedUid){
                const feed = this.feeds.find((f) => f.uid === this.$route.params.feedUid);
                this.selectFeed(feed);
                if(this.$route.params.edit){
                    this.onUpdateFeed();
                }
            }
        },
        onUpdateRights(){
            this.$refs.nsLoader.triggerRefresh().then(() => {
                this.$eventBus.$emit('broadcast-right-save-ended');
            });
        },
        onFeedStopped (){
            this.$refs.nsLoader.triggerRefresh();
            this.$set(this, 'selectedFeed', null);
        }
    }
};
</script>

<style lang="scss">
.feed-view{
    .right-part{
        height: 100%;
        overflow: auto;
    }
    .simple-layout-title{
        font-family: roboto;
        margin-left: 12px;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/index.vue